module.exports = __webpack_public_path__ + "static/media/whiteDownload.7b2ee8ef.svg";